import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

const HandbookEmbedContext = createContext(null);

export function HandbookEmbedProvider({ children }) {
  const iframeRef = useRef(null);
  const [embedReady, setEmbedReady] = useState(false);

  const setIframeEl = useCallback((el) => {
    iframeRef.current = el;
    if (!el) setEmbedReady(false);
  }, []);

  const postToEmbed = useCallback((msg) => {
    const w = iframeRef.current?.contentWindow;
    if (w) w.postMessage(msg, window.location.origin);
  }, []);

  const value = {
    iframeRef,
    setIframeEl,
    postToEmbed,
    embedReady,
    setEmbedReady,
  };

  return (
    <HandbookEmbedContext.Provider value={value}>{children}</HandbookEmbedContext.Provider>
  );
}

export function useHandbookEmbed() {
  return useContext(HandbookEmbedContext);
}
